import { useEffect, useState } from 'react';
import { useTestContext } from '../../../context/testContext';
import { useOptimaData } from '../../../helpers/reducers';
import { Button, PanelTitle, SessionActions } from '../../../ui';
import { ExamBody, Row, useConfirmNavigation } from '../exams/common';
import { NearVisionLines } from '../exams/NearVisionLines';

const ICNVisionTest = ({ eyeTested, updateTextContents, updateStep }) => {
  const [canProgress, setCanProgress] = useState(false);
  const { testData, updateTestData } = useTestContext();
  const confirmNavigation = useConfirmNavigation();
  const {
    currentOptimaData: { optimaSize, optimaGroup },
    updateOptimaData,
  } = useOptimaData();

  useEffect(() => {
    updateTestData({ testInProgress: true });
  }, [updateTestData]);

  useEffect(() => {
    updateOptimaData({ type: 'setInitialOptimaGroup', payload: testData.startingTextSize });
  }, [updateOptimaData, testData.startingTextSize]);

  useEffect(() => {
    updateTextContents(optimaGroup);
    setCanProgress(false);
    updateOptimaData({ type: 'setOptimaSize', payload: null });
  }, [optimaGroup, updateOptimaData, updateTextContents]);

  useEffect(() => {
    if (!optimaSize) return;
    const getMagnificationByTextSize = () => {
      const sizeDetails = optimaGroup?.fontSizes.find((obj) => obj.key === optimaSize);
      return sizeDetails?.magnification;
    };

    const magnification = getMagnificationByTextSize();
    updateTestData({ [eyeTested]: { textSizeRead: optimaSize, magnification: magnification } });
  }, [optimaSize, optimaGroup?.fontSizes, updateTestData, eyeTested]);

  return (
    <ExamBody style={{ gap: 16 }}>
      <PanelTitle small style={{ marginBottom: 0 }}>
        {optimaGroup?.value}
      </PanelTitle>
      <NearVisionLines
        lines={optimaGroup?.fontSizes || []}
        selected={optimaSize}
        onSelect={(key) => {
          updateOptimaData({ type: 'setOptimaSize', payload: key });
          return setCanProgress(true);
        }}
      />
      <Row justify='center' gap={12}>
        <Button variant='secondary' size='lg' onClick={() => updateOptimaData({ type: 'nextOptimaGroup' })} disabled={!optimaGroup?.navigation.next}>
          Smaller
        </Button>
        <Button variant='secondary' size='lg' onClick={() => updateOptimaData({ type: 'previousOptimaGroup' })} disabled={!optimaGroup?.navigation.previous}>
          Bigger
        </Button>
      </Row>
      <SessionActions
        onBack={() =>
          confirmNavigation().then(() => {
            updateTestData({ [eyeTested]: null, testInProgress: false });
            updateStep(`${eyeTested}Setup`);
          })
        }
        primary={{ label: 'Next', onClick: () => updateStep('results'), disabled: !canProgress }}
      />
    </ExamBody>
  );
};

export default ICNVisionTest;
